import React from 'react'
import { motion } from 'motion/react'
import { BackendKeywordTag } from '../../constants/tags'
import KeywordTag from './KeywordTag'
import { STACKED_COLUMN_MAX_ITEMS } from './utils'
import { columnVariants, getColumnDelay } from './filterAnimation'
import { cn } from '../../utils/cn'

interface KeywordColumnProps {
  // the column's place in the list, it staggers the column's rise in
  index: number
  letter: string
  items: BackendKeywordTag[]
  language: string
  minCount: number
  maxCount: number
  onSelectKeyword: (keywordId: number) => void
}

const KeywordColumn = ({
  index,
  letter,
  items,
  language,
  minCount,
  maxCount,
  onSelectKeyword,
}: KeywordColumnProps) => {
  const style = { '--column-delay': `${getColumnDelay(index)}s` } as React.CSSProperties

  // rises in following the overlay's variant
  return (
    <motion.div
      className="group flex h-full max-h-full min-w-[max-content] flex-row items-stretch rounded-[0.5rem] px-0 py-[0.5rem] max-sm:min-w-[max-content] max-sm:max-w-none max-sm:px-0 max-sm:py-[0.25rem]"
      variants={columnVariants}
      custom={index}
      style={style}
    >
      <div className="flex h-full flex-col items-center justify-center pb-[0rem] pl-[4rem] pr-[2rem] pt-[1rem] font-approach-regular text-[5rem] text-grey40 max-sm:pb-[0.5rem] max-sm:pl-[0.75rem] max-sm:pr-[0.5rem] max-sm:pt-[0.5rem] max-sm:text-[3.5rem]">
        <div className="column-letter [transition:color_0.3s_ease] group-data-[active]:text-red">
          {letter}
        </div>
        <div className="invisible">{letter}</div>
      </div>
      <div
        className={cn(
          'mx-auto my-0 flex max-h-full max-w-none flex-wrap content-center items-center justify-center gap-[6px] overflow-visible px-[0.5rem] py-[1rem] max-sm:h-full max-sm:gap-[5px] max-sm:px-[0.75rem] max-sm:py-[0.5rem]',
          {
            'w-min flex-col': items.length <= STACKED_COLUMN_MAX_ITEMS,
            'flex-row': items.length > STACKED_COLUMN_MAX_ITEMS,
          },
        )}
      >
        {items.map(keyword => (
          <KeywordTag
            key={keyword.id}
            keyword={keyword}
            language={language}
            minCount={minCount}
            maxCount={maxCount}
            onSelect={onSelectKeyword}
          />
        ))}
      </div>
    </motion.div>
  )
}

export default React.memo(KeywordColumn)
